import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";

const TenantsPage = lazy(async () => {
  const module = await import("@/features/admin/tenants/ui/TenantsPage");
  return { default: module.TenantsPage };
});

export const adminRouteElements = (
  <>
    <Route path="/" element={<Navigate to="/tenants" replace />} />
    <Route path="/tenants" element={<TenantsPage />} />
    <Route path="*" element={<Navigate to="/tenants" replace />} />
  </>
);
